// extracted by css-extract-rspack-plugin
export default {"cls1":"Unibrow-cls1_JBb","cls2":"Unibrow-cls2_tqS Unibrow-cls1_JBb"};